module.exports = __webpack_public_path__ + "static/media/wedding_party.61687e01.png";